"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const languageMsg = {
  MANAGE_YOUR_TEAM: 'Manage your team',
  VIEW_USERS: 'View Users',
  EMPTY_RECORDS: 'No Records Found',
  ACTIVE_FROM: 'Active From:',
  REMOVED_ON: 'Removed on:',
  SELECT_APP_ROLE: 'Select app role',
  DELETE_CONFIRMATION: 'Are you sure you want to remove access for',
  CANCEL: 'Cancel',
  REMOVE_ACCESS: 'Remove Access'
};
var _default = exports.default = languageMsg;